import type { ObjectMetadata } from '@olytic/foundation';

import { formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['product-options'];
const quantity = show((v) => formatNumber(v));

/** One option of a bundle product. Rationale: product-options.md. */
export const productOptions: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Option',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('bundle_product_name', 'Bundle', { link: lookup('products', 'bundle_product_id') }),
    field('option_product_name', 'Product', { link: lookup('products', 'option_product_id') }),
    field('option_group', 'Group'),
    field('default_quantity', 'Default Quantity', { format: quantity }),
    field('required', 'Required', { format: asCheck }),
    field('included', 'Included in the Bundle', { format: asCheck }),
    field('min_quantity', 'Minimum', { format: quantity }),
    field('max_quantity', 'Maximum', { format: quantity }),
    field('sort_order', 'Order'),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['bundle_product_name', 'option_product_name', 'option_group', 'default_quantity', 'required', 'included'] },
    { key: 'quantities', label: 'Quantities', fields: ['min_quantity', 'max_quantity', 'sort_order'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'bundle_product_name', 'option_product_name', 'option_group'],
};
